import baseService from './baseService';

export const updateCandidate = (uuid, params) => {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  const { candidate, pdfFiles } = params;
  const { pdf_file_ids, general_question_attributes, links_json, skill_ids } = candidate;
  const data = new FormData();
  const current_title = general_question_attributes.questions.find((ques) => ques.question === 'current_title');
  const current_employer = general_question_attributes.questions.find((ques) => ques.question === 'current_employer');
  const license_available = general_question_attributes.questions.find((ques) => ques.question === 'license_available');

  data.append('general_question_attributes', JSON.stringify(general_question_attributes));
  data.append('links_json', JSON.stringify(links_json));
  data.append('pdf_file_ids', JSON.stringify(pdf_file_ids));
  data.append('skill_ids', JSON.stringify(skill_ids));
  data.append(
    'current_location',
    JSON.stringify(
      candidate.location || {
        city: '',
        country: '',
        state: '',
        full_address: '',
      }
    )
  );
  data.append('current_title', current_title.answer);
  data.append('current_employer', current_employer.answer);
  data.append('license_available', license_available.answer);

  pdfFiles.forEach(({ pdf }) => {
    data.append('pdf_files_attributes[]', pdf);
  });

  return baseService.patch(`/member/candidate_strength_questions/${uuid}`, data, config);
};
